import { useState } from "react";

import { Confirmation } from "@/app/_components/confirmation";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

import { useDeleteViability } from "@/queries/mutations/use-delete-viability";

interface DeleteViabilityCalculatorProps {
  id: string;
  onSave?: () => void;
}

export const DeleteViabilityCalculatorDialog = ({
  id,
  onSave,
}: DeleteViabilityCalculatorProps) => {
  const deleteViabilityCalculator = useDeleteViability();
  const [isDeleting, setIsDeleting] = useState(false);

  const remove = async () => {
    setIsDeleting(true);

    await deleteViabilityCalculator.mutateAsync(id);

    setIsDeleting(false);
    onSave?.();
  };

  return (
    <Confirmation
      title="Remover cálculo"
      description="Tem certeza que deseja remover este cálculo?"
      confirm={{
        disabled: isDeleting,
        label: isDeleting ? (
          <>
            <Spinner inverse /> Removendo
          </>
        ) : (
          "Continuar"
        ),
        onClick: remove,
      }}
    >
      <Button type="button" variant="ghost">
        Remover cálculo
      </Button>
    </Confirmation>
  );
};
